export default __webpack_public_path__ + "static/media/GF_MIKE_KRUSH.a6635d12.jpg";